<!--操作记录 operateRecords-->
<template>
  <div class="myoperateRecord">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>对象：</span>
              <el-input v-model="userName" type="text" class="numberInput" autocomplete="off"
                placeholder="请输入对象"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>类型：</span>
             <el-select v-model="noticeType" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small ">
              <span>日期：</span>
             <el-date-picker v-model="dataTime" type="date" placeholder="选择日期"></el-date-picker>
            </div>

             
            <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>
      </div>
    
      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table :data="dataList" :height="heights - 20" border style="width: 100%;" v-loading="loading" stripe>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号"  align="center">
          </el-table-column>
          <el-table-column prop="noticeType" label="记录类型" :formatter="noticeTypeFormatter">
          </el-table-column>
          <el-table-column prop="createName" label="操作人">
          </el-table-column>
          <el-table-column prop="userName" label="对象">
          </el-table-column>
          <el-table-column prop="content" label="记录内容">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" :formatter="dataTimeFormatter">
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
      <RefundDialog ref="refundDialog"></RefundDialog>
    </div>
  </div>
</template>

<script>
  import datePicker from '@/components/module/universal/datePicker.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import RefundDialog from './dialogs/RefundDialog.vue'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      datePicker,
      singleSelection,
      infoListMultipleSelection,
      RefundDialog,
      elPagination
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-240,
        dataList: [],
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        dataTime: '',
        userName: '',
        filterTime: false,
        searchChange: false,
        noticeClass: 0,
        noticeType: '',
        loading: false,//加载
        typeList: [{
          label: '催缴',
          value: 0
        },{
          label: '充值',
          value: 1
        },{
          label: '退费',
          value: 2
        },{
          label: '扣费',
          value: 3
        },{
          label: '拉闸',
          value: 4
        },{
          label: '合闸',
          value: 5
        },{
          label: '开户',
          value: 6
        },{
          label: '销户',
          value: 7
        },{
          label: '全部',
          value: ''
        }],
      }
    },
    created () {},
    mounted () {
      this.search()
    },
    destroyed () {},
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getOperateRecordsTimeInterval
      },
    },
    watch: {},
    methods: {

      search () {
        // console.log("搜索");
        var beginTime=''
        var endTime=''
        if(!isempty(this.dataTime)) {
          let dataTime=new Date(this.dataTime).format('yyyy-MM-dd')
          beginTime=new Date(dataTime+' 00:00:00').getTime()
          endTime=new Date(dataTime+' 23:59:59').getTime()
        }
        this.loading=true
        this.$api.noticeApi.getUnitNoticeLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.noticeClass,this.noticeType,beginTime,endTime,this.userName,respon => {
          this.dataList=respon.dataList
          this.total=respon.total
          this.loading=false
        },err => {
          this.$message.error(err);
          this.loading=false
        })
      },
      backout (item) {
        this.$refs.refundDialog.open(result => {
          this.$api.meterReadingApi.refund(item.id,result.fee,result.password,respon => {
            this.$message({
              message: respon,
              type: 'success'
            })
            this.search()
          },err => {
            this.$message.error(err);
          })
        })
      },
      // 批量导出
      exportReport () {
        var beginTime=this.filterTime? this.nowTimeInterval.startDate.getTime():undefined
        var endTime=this.filterTime? this.nowTimeInterval.endDate.getTime():undefined
        var title=this.nowUnit.name+'操作记录信息'
        this.$store.cacheStore.state.load=true
        this.$api.noticeApi.exportUnitNotice(this.nowUnit.id,this.noticeClass,this.noticeType,beginTime,endTime,this.userName,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
          this.$store.cacheStore.state.load=false
        },err => {
          this.$store.cacheStore.state.load=false
          this.$dialogMethod.showMessage(err)
        })
      },
      noticeTypeFormatter (row,column) {
        //记录类型格式化
        return this.typeList[row.noticeType].label
      },
      dataTimeFormatter (row,column) {
        //格式化日期
        return new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss")
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },

    }
  }
</script>

<style scoped lang="scss">
  .myoperateRecord {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      background-color: #fff;
      box-sizing: border-box;

    }
    .search-input-btn {
      margin-top: 0px;
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
</style>